import { useEffect } from "react";

import { IActionForProvider } from "../../Actions/actions";
import { usePromiseStatus } from "../Hooks/usePromiseStatus";


export type ConfirmPopupProps = {
    action: IActionForProvider<void, boolean>;
    title: string;
    text: string | string[];
    yesText?: string;
    noText?: string;
    getWorkerPromise?: () => Promise<any>;
}

export const useConfirmPopup = (props: ConfirmPopupProps) => {

    const workerStatus = usePromiseStatus<any>();

    const handleYes = () => {

        if (props.getWorkerPromise) {
            const promise = props.getWorkerPromise();
            promise.then(() => {
                props.action.complete(true);
            });
            workerStatus.setPromise(promise);
        } 
        else {
            props.action.complete(true);
        }

    };

    useEffect(() => {
        workerStatus.clear();
    }, [props.action.isActive, workerStatus])

    const textParts = Array.isArray(props.text) ? props.text : [props.text];

    return {
        workerStatus,
        handleYes,
        textParts
    };

};
